/**
 * @author gyb(mocheer)
 * @since 2016.11.4
 * 台风图元
 */
import lonlats from '../utils/LonLats';
import Quadrant from '../marker/Quadrant';
import Popup from '../polyfill/Popup';
import PathMarker from '../marker/PathMarker'
let { marker: toMarker, canvas: toCanvas, polyline: toPolyline, circle: toCircle, circleMarker, divIcon: toDivIcon, tooltip: toTooltip, featureGroup: toGroup, latLng: toLatLng } = L;
let { assign: $assign } = T;

/**
 * 台风图元
 * @class Typhoon
 */
export default class Typhoon {
  /**
   * 配置信息
   */
  options = {
    // 自动播放
    autoPlay: true,
    // 是否绘制台风路径
    hasLsljLater: true,
    // 确保台风在视野范围内
    inView: true,
    // 历史路径
    ls: { color: '#0000c8', weight: 1 },
    // 历史路径-灰色
    lsyb: { color: '#666666', weight: 1, opacity: 0.5, interactive: false },
    // 预报机构,预报路径点
    org: { weight: 1, dashArray: '10,3', interactive: false },
    orgs: [
      { label: "中国", th: "CN", color: "#FF4050" },
      { label: "韩国", th: "KR", color: "#000000" },
      { label: "美国", th: "US", color: "#4099EE" },
      { label: "中国台湾", th: "TW", color: "#FFA040" },
      { label: "日本", th: "JP", color: "#43FF4B" },
      { label: "中国香港", th: "HK", color: "#FF40F5" }
    ],
    // 台风等级
    grade: { color: '#000', radius: 4, fillColor: '#FFF', weight: 1, fillOpacity: 1, src: 'circle' },
    grades: [
      { F1: 0, F2: 0.2 },
      { F1: 0.3, F2: 1.5 },
      { F1: 1.6, F2: 3.3 },
      { F1: 3.4, F2: 5.4 },
      { F1: 5.5, F2: 7.9 },
      { F1: 8, F2: 10.7 },
      { F1: 10.8, F2: 13.8, fillColor: '#00FF03', GRADENAME: '热带低压' },
      { F1: 13.95, F2: 17.15, fillColor: '#00FF03', GRADENAME: '热带低压' },
      { F1: 17.2, F2: 20.7, fillColor: '#0062FE', GRADENAME: '热带风暴' },
      { F1: 20.8, F2: 24.4, fillColor: '#0062FE', GRADENAME: '热带风暴' },
      { F1: 24.5, F2: 28.4, fillColor: '#FDFA00', GRADENAME: '强热带风暴' },
      { F1: 28.5, F2: 32.6, fillColor: '#FDFA00', GRADENAME: '强热带风暴' },
      { F1: 32.7, F2: 36.9, fillColor: '#FDAC03', GRADENAME: '台风' },
      { F1: 37, F2: 41.4, fillColor: '#FDAC03', GRADENAME: '台风' },
      { F1: 41.5, F2: 46.1, fillColor: '#F072F6', GRADENAME: '强台风' },
      { F1: 46.2, F2: 50.9, fillColor: '#F072F6', GRADENAME: '强台风' },
      { F1: 51, F2: 56, fillColor: '#FD0002', GRADENAME: '超强台风' },
      { F1: 56.1, F2: 161.2, fillColor: '#FD0002', GRADENAME: '超强台风' }
    ],
    // 台风风圈
    c7: { fillColor: '#79C0AE', fillOpacity: 0.5, color: '#49BA6E', weight: 1 },
    c10: { fillColor: '#FFFF00', fillOpacity: 0.2, color: '#FFFF00', weight: 1 },
    c12: { fillColor: '#FF0000', fillOpacity: 0.3, color: '#FF0000', weight: 1 },
    // 台风风眼
    // hurricane: {iconUrl: T + "assets/common/dmap/markers/typhoonIco.gif",iconSize: [32, 32]}
    // 
  }
  // 
  group = toGroup();
  //
  /**
   * 
   * @param {*} data 
   * @param {*} style 
   */
  constructor(data, options) {
    this.data = data;
    options = $assign(this.options, options);
    options.grades = options.grades.map(val => $assign({}, options.grade, val));
    //
    this._points = [];
  }
  /**
   * 
   * @param {*} options 
   */
  setOptions(options) {
    $assign(this.options, options);
    this.update();
  }
  /**
   * 更新重绘
   */
  update() {
    this.draw(this.ci);
  }
  /**
   * 创建路径点
   * @param coor
   * @param options
   * @param data
   */
  createPoint(coor, options, data) {
    let marker = circleMarker(lonlats(coor), options);
    data._source = this.data;
    marker.__data = data;
    // 创建弹出层
    options = this.options.popup;
    options && marker.bindPopup(new Popup(options), options);
    return marker;
  }
  /**
   * 创建路径线
   * @param coor
   * @param style
   */
  createPolyline(coor, style) {
    return toPolyline(lonlats(coor, 1), style);
  }
  /**
   * 创建风圈
   * @param center
   * @param radius
   * @param options
   */
  createCicle(center, radius, options) {
    return radius && toCircle(lonlats(center), radius * 1000, options);
  }
  /**
   * 绘制四象风圈
   * { ne, nw, sw, se}-> [ne, nw, sw, se]
   * @param center
   * @param radius
   * @param style
   */
  createQuadrant(center, radius, style) {
    if (!radius) return;
    let { ne, nw, sw, se } = radius;
    if (!ne || !nw || !sw || !se) {
      return;
    }
    this.renderer = this.renderer || toCanvas({ style: { zIndex: 40 } });
    return new Quadrant([center[1], center[0]], $assign({}, style, { renderer: this.renderer, radius: [ne * 1000, nw * 1000, sw * 1000, se * 1000] }))
  }
  /**
   * 绘制飓风动画
   * todo canvas 重写
   * @param center
   * @param options
   */
  createHurricane(center, options, grade) {
    let colorIndex = parseInt((grade - 6) / 2) + 1;
    return options ? toMarker(lonlats(center), {
      icon: toDivIcon(options)
    }) : new PathMarker(lonlats(center), {
      src: T + `assets/common/dmap/typhoon/hurricane${colorIndex > 0 ? colorIndex : 0}.png`,
      rotate: true
    })
  }
  /**
   * draw
   * {points}
   * {radius7,radius10,radius12,radius7_quad,radius10_quad,radius12_quad}-> {r7,r10,r12,r7_q,r10_q,r12_q}
   * {lng,lat} -> {lon,lat}
   * {power,strong} 台风等级,台风等级对应名称
   * {sets,points} 预报机构，预报路径
   * @param time
   */
  draw(time) {
    let that = this;
    let { options, data, group, lsp, createPolyline, createCicle, _points } = that;
    let { autoPlay, ls, lsyb, grades, c7, c10, c12, org, orgs, hurricane, hasLsljLater } = options;
    let createPoint = that.createPoint.bind(that);
    let createQuadrant = that.createQuadrant.bind(that);
    let handleEvent = that.handleEvent.bind(that);
    let { points } = data;
    let ci = this.getTimeIndex(points, time);//当前台风时间点，默认为台风消亡时间点
    let len = points.length;
    let addLayer = (value, index, array) => {
      if (!value || (array === lsp && index > ci && autoPlay)) return;
      group.addLayer(value);
    }
    let getDistance = (p1, p2) => Math.sqrt((p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y));
    //
    let drawing = i => {
      // 清除
      group.clearLayers();
      // 声明
      let lslj;     // 历史路径
      let lslj_yb;  // 历史路径-灰色
      let yblj = [];// 预报路径
      let tffq = [];// 台风风圈
      // 
      let item = points[i];
      let lslj_prev = points.slice(0, i + 1);
      let lslj_after = points.slice(i);
      let coor = [item.lng, item.lat];
      // 绘制历史路径
      if (lslj_prev.length > 1) {
        lslj = createPolyline(lslj_prev, ls);
      }
      // 绘制历史路径-灰色
      if (!autoPlay && hasLsljLater && lslj_after.length > 1) {
        lslj_yb = createPolyline(lslj_after, lsyb);
        lslj_prev = lslj_prev.concat(lslj_after.slice(1));
      }
      lsp.length = lslj_prev.length;
      // 历史路径点
      lslj_prev.forEach((item, i) => {
        let point = item._point = this.map.latLngToLayerPoint(toLatLng(item.lng, item.lat));
        let point_prev = (function (i) {
          while (i--) {
            if (lsp[i]) return lslj_prev[i]._point;
          }
        })(i);
        //  抽稀
        if ((i > 0 && getDistance(point, point_prev) < 5)) {
          lsp[i] = null
          return;
        }
        // 
        let marker = lsp[i] = _points[i] = _points[i] || createPoint([item.lng, item.lat], grades[item.power || 0], item).on('click mouseover mouseout', handleEvent);
        if (i === 0) {
          let tooltip = toTooltip({ permanent: true, direction: 'right', offset: [5, 0] }, marker).setContent(data.tfbh + data.name);
          marker.bindTooltip(tooltip);
        }
      })

      // 绘制风圈和预报路径
      if (autoPlay || i === ci) {
        let { radius7_quad, radius10_quad, radius12_quad, forecast } = item;
        // 绘制飓风动画和风圈
        let h = that.createHurricane(coor, hurricane, item.power);
        let r7 = createQuadrant(coor, radius7_quad, c7) || createCicle(coor, item.radius7, c7);
        let r10 = createQuadrant(coor, radius10_quad, c10) || createCicle(coor, item.radius10, c10);
        let r12 = createQuadrant(coor, radius12_quad, c12) || createCicle(coor, item.radius12, c12);
        tffq.push(r7, r10, r12, h);
        // 绘制预报路径：回溯 
        let _points = [];
        orgs.forEach(data => {
          let sets = data.label;//预报机构名称
          let index = i;
          let item;
          let point;
          let search = { sets: sets };
          while (!item && index >= 0) {
            point = points[index--];
            forecast = point.forecast;
            item = forecast && T.find(forecast, search);
          }
          if (item) {
            let { sets, points } = item;
            let style = $assign({}, org, T.find(orgs, { label: sets }));
            yblj.push(createPolyline([point].concat(points), style));

            points.forEach((item, i) => {
              item.sets = sets;// 用于显示信息窗
              // 抽稀
              let point = item._point = this.map.latLngToLayerPoint(toLatLng(item.lng, item.lat));
              for (let j = 0, len = _points.length; j < len; j++) {
                if (getDistance(point, _points[j]) < 5) {
                  return;
                }
              }
              _points.push(point);
              //
              yblj.push(createPoint(item, grades[item.power || 0], item).on('mouseover mouseout', handleEvent))
            })
          }
        })
      }
      //
      tffq.forEach(addLayer);
      yblj.forEach(addLayer);
      addLayer(lslj);
      addLayer(lslj_yb);
      lsp.forEach(addLayer);
    }
    that.ci = ci;
    if (autoPlay) {
      let i = 0;
      let playing = () => {
        //init 防止播放过程中就被移除
        if (this.init) {
          if (i < len && that.layer) {
            drawing(i++);
            setTimeout(playing, 30);
          } else if (that.layer) {
            T.do('typhoon-playend', { tf: data, attr: points[i - 1] })
            options.autoPlay = false;
            that.complete = true;
          }
          // 视野切换
          if ((i === len) && options.inView && !this.layer.suspended) {
            let bound = toPolyline([[30, 105], [10, 125]].concat(points)).getBounds();
            (this.map && options.keepZoom) ? this.map.setView(bound.getCenter()) : this.map.fitBounds(bound);
          }
        }
      }
      playing();
    } else {
      drawing(ci);
      T.do('typhoon-playend', { tf: data, attr: points[ci] })
      that.complete = true;
    }
  }
  /**
   * 获取台风播放时间点
   * @param data 
   * @param time 
   */
  getTimeIndex(data, time) {
    if (time !== void 0) {
      return +time;
    }
    return data.length - 1;
  }
  /**
   * 设置台风播放时间点
   * @param time
   */
  setTimeIndex(time) {
    if (this.ci !== time) {
      if (this.complete) {
        this.draw(time);
      }
    }
  }
  /**
   * 
   * @param layer 
   */
  addTo(layer) {
    let that = this;
    if (layer.map) {
      that.map = layer.map.on('zoomend', () => { that.init && that.update() });
      that.layer = layer;
      layer._add(this.group);
      if (!that.init) {
        that.init = true;
        that.lsp = [];
        that.draw();
      }
    }

  }
  /**
   * 移除
   */
  remove() {
    this.init = false;
    // 不能直接用 remove，当上层layer被挂起的时候无法删除。
    // 所以这里用 removeFrom
    this.group.removeFrom(this.layer.layer);
  }
  /**
   * 台风路径点点击/移入事件
   * @param e
   */
  handleEvent(e) {
    let { data, lsp, complete, _overTarget } = this;
    let { target, type } = e;
    let i = lsp.indexOf(target);
    if (!complete) {
      return;
    }
    switch (type) {
      case 'click':
        if (lsp[i]) {
          this.setTimeIndex(i);
          target.openPopup();
          //台风播放控件
          T.do('typhoon-lslj-click', { data: data, dataProvider: data.points, selItem: data.points[i], event: e });
        }
        break;
      case 'mouseover':
        if (lsp[i]) {
          if (_overTarget != target) {
            target.setRadius(target.getRadius() + 3);
            this._overTarget = target;
          }
          T.do('typhoon-lslj-over', { tf: data, attr: target.__data || data.points[i], event: e });
        }
        break;
      case 'mouseout':
        if (_overTarget) {
          _overTarget.setRadius(_overTarget.getRadius() - 3);
          this._overTarget = null;
        }
        T.do('typhoon-lslj-out');
        break;
    }
  }
}


// WEBPACK FOOTER //
// ./src/marker/Typhoon.js